import { useState } from "react";
import {
  Wrapper,
  PlayerBtn,
  PlayerBtnText,
  PlayerBtnWrapper,
} from "./PlayerHeader.styled";
import shareIcon from "../../assets/share-social-outline.png";
import fullIcon from "../../assets/expand-outline.png";
import infoIcon from "../../assets/alert-circle-outline.png";
import ShareModal from "../ShareModal";

function PlayerHeader({ onFullscreen, onInfo }) {
  const [modalIsOpen, setIsOpen] = useState(false);

  function openModal() {
    setIsOpen(true);
  }

  function closeModal() {
    setIsOpen(false);
  }

  return (
    <Wrapper>
      <PlayerBtnWrapper onClick={onFullscreen}>
        <PlayerBtn src={fullIcon} />
        {/* <PlayerBtnText>מסך מלא</PlayerBtnText> */}
      </PlayerBtnWrapper>
    </Wrapper>
  );
}

export default PlayerHeader;
